module.exports = __webpack_public_path__ + "static/img/0401_02.967c222.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/04/0401_02.png
// module id = 4+B4
// module chunks = 1